module.exports = __webpack_public_path__ + "static/media/ofMarketing.5f05d4c5.jpg";